import { scoreColor, scoreLabel } from '../scoreUtils';

interface Props {
  score: number;
  size?: 'sm' | 'md' | 'lg';
  showLabel?: boolean;
}

/** 総合/カテゴリスコアを色付き円で表示 */
export default function ScoreBadge({ score, size = 'md', showLabel = false }: Props) {
  const color = scoreColor(score);
  const dim = size === 'lg' ? 128 : size === 'md' ? 64 : 40;
  const fontSize = size === 'lg' ? 40 : size === 'md' ? 22 : 15;

  return (
    <div className="score-badge" style={{ width: dim }}>
      <div
        className="score-badge__circle"
        style={{
          width: dim,
          height: dim,
          borderColor: color,
          color,
          fontSize,
        }}
      >
        {Math.round(score)}
      </div>
      {showLabel && (
        <span className="score-badge__label" style={{ color }}>
          {scoreLabel(score)}
        </span>
      )}
    </div>
  );
}
